(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
		.controller('VentaDetailController', VentaDetailController);

    VentaDetailController.$inject = ['$scope', '$rootScope', '$stateParams', '$filter','previousState', 'entity', 'Venta', 'Zeta'];
				
    function VentaDetailController($scope, $rootScope, $stateParams, $filter, previousState, entity, Venta, Zeta) {
		
		//$rootScopeProvider.digestTtl(500);
		
        var vm = this;
		
        vm.venta = entity;
        vm.previousState = previousState.name;
		vm.totalizado= 0.00;

        vm.listaAeropuertos = null;
		vm.seleccionAeropuerto = "<Todos>";
		vm.arrayAeropuertos = null;
		
        vm.zetas = [];
        loadAll();

        function loadAll() {
            Zeta.queryByVenta({id: vm.venta.id}, function(result) {
                vm.zetas = result;
                vm.searchQuery = null;
				//
				vm.listaAeropuertos= new Map();
				result.forEach(function(zeta){
						if(!vm.listaAeropuertos.has(zeta.aeropuerto)){				//https://codeburst.io/javascript-array-distinct-5edc93501dc4
							vm.listaAeropuertos.set(zeta.aeropuerto, true);    // set any value to Map
							}
						})  
				vm.arrayAeropuertos = Array.from(vm.listaAeropuertos.keys());//console.log(vm.arrayAeropuertos);
				vm.arrayAeropuertos.sort();
				vm.arrayAeropuertos.unshift("<Todos>");
				//
				var maxl=vm.zetas.length;
				$scope.vm.totalizado=0;
				for (var i = 0; i < maxl; i++) { 
				  var zet = vm.zetas[i];
				  //es + ncredito porque tienen signo negativo.
				  vm.totalizado += (zet.ticketsmontoventas+zet.ticketsmontoncredito);
				}
				});
        }
		

		function soloUnAeropuerto()
		{
		if( !vm.seleccionAeropuerto ||	!vm.seleccionAeropuerto.length)
			return false;
		if("<Todos>" === vm.seleccionAeropuerto)
			return false;
		return true;
		}
    	
		//gracias maestra: https://teamtreehouse.com/community/angularjs-building-a-calculate-total-function-on-ngrepeat
		$scope.calcTotal = function(aeropuerto){
			if( !$scope.vm.seleccionAeropuerto ||	!$scope.vm.seleccionAeropuerto.length)
				return 0;
			if("<Todos>" === $scope.vm.seleccionAeropuerto){
				vm.totalizado=0;
				var maxl=vm.zetas.length;
				for (var i = 0; i < maxl; i++) { 
					var zet = vm.zetas[i];
					vm.totalizado += (zet.ticketsmontoventas+zet.ticketsmontoncredito);
					}
				return vm.totalizado;
				}
			//
			vm.totalizado=0;
			var maxl=vm.zetas.length;
			for (var i = 0; i < maxl; i++) { 
				var zet = vm.zetas[i];
				if(zet.aeropuerto === $scope.vm.seleccionAeropuerto){
					vm.totalizado += (zet.ticketsmontoventas+zet.ticketsmontoncredito);
					}
				}
			return vm.totalizado;
		}

		$scope.filtraPorAeropuerto = function (zeta) {
			if( !$scope.vm.seleccionAeropuerto ||	!$scope.vm.seleccionAeropuerto.length)
				return true;
			if("<Todos>" === $scope.vm.seleccionAeropuerto){
				/*
				vm.totalizado=0;
				var maxl=vm.zetas.length;
				for (var i = 0; i < maxl; i++) { 
					var zet = vm.zetas[i];
					vm.totalizado += (zet.ticketsmontoventas+zet.ticketsmontoncredito);
					}
				*/
				return true;
				}
			
			if(zeta.aeropuerto === $scope.vm.seleccionAeropuerto){
				//$scope.vm.totalizado = $scope.vm.totalizado + (zeta.ticketsmontoventas+zeta.ticketsmontoncredito);
				return true;	
				}
			return false;
		}
		
        var unsubscribe = $rootScope.$on('mVtasWebApp:ventaUpdate', function(event, result) {
            vm.venta = result;
        });
        $scope.$on('$destroy', unsubscribe);
				
		var mystyle = {
			  sheetid: 'Ventas dia',
			  headers:true, 
			  caption: {
				  title:'Ventas',
				  style:'font-size: 50px; color:blue;' 
				},
				style:'font-size:30px',
				column: {style:{Font:{Bold:"1"}}},
				rows: {1:{style:{Font:{Color:"#FF0077"}}}},
				cells: {1:{1:{
					style: {Font:{Color:"#00FFFF"}}
				}}}
		};
					
					
		var fechasel= vm.venta.fecha;
		//var nombrearchivoexcel= fechasel.getFullYear() + '' + (fechasel.getMonth()+1) + '' + fechasel.getDate();
		
		vm.exportDataExcel = function () {
			
			vm.zetasfiltrada = angular.copy(vm.zetas.filter($scope.filtraPorAeropuerto));			
		
			var nombrearchivoexcel= fechasel.getFullYear() + '' + (fechasel.getMonth()+1) + '' + fechasel.getDate();		
			if(soloUnAeropuerto()==true){
				nombrearchivoexcel= fechasel.getFullYear() + '' + (fechasel.getMonth()+1) + '' + fechasel.getDate()	+ '_Aeropuerto(' + vm.zetasfiltrada[0].aeropuerto.replace(/\s+/g, '-') + ')';
				}
				
			alasql('SELECT aeropuerto, comercio,ip, ticketsmontoventas as VentasMonto, totalefectivo, totaltarjeta, ticketscantventas as VentasTickets, itemscantventas as VentasItems, ticketsmontoventas/ticketscantventas as ticketpromedio, ticketsmontoncredito as NotasDeCreditosMonto,  ticketscantncredito as NotasDeCreditoTickets,itemscantncredito as NotasDeCreditoItems INTO XLSX("VentaDelDia_'+ nombrearchivoexcel + '",?) FROM ?', [mystyle,vm.zetasfiltrada]);   
			};
			
		vm.exportDataCSV = function () {
			
			vm.zetasfiltrada = angular.copy(vm.zetas.filter($scope.filtraPorAeropuerto));			
			var nombrearchivoexcel= fechasel.getFullYear() + '' + (fechasel.getMonth()+1) + '' + fechasel.getDate();
			if(soloUnAeropuerto()==true){
				nombrearchivoexcel= fechasel.getFullYear() + '' + (fechasel.getMonth()+1) + '' + fechasel.getDate()	+ '_Aeropuerto(' + vm.zetasfiltrada[0].aeropuerto.replace(/\s+/g, '-') + ')';
				}
			
			alasql('SELECT aeropuerto, comercio,ip, ticketsmontoventas as VentasMonto, totalefectivo, totaltarjeta, ticketscantventas as VentasTickets, itemscantventas as VentasItems, ticketsmontoventas/ticketscantventas as ticketpromedio,ticketsmontoncredito as NotasDeCreditosMonto,  ticketscantncredito as NotasDeCreditoTickets,itemscantncredito as NotasDeCreditoItems INTO CSV("VentaDelDia_'+ nombrearchivoexcel + '",?) FROM ?', [mystyle,vm.zetasfiltrada]);   
			};			
    }
})();













